import React from "react";
import { Redirect, Route, Switch } from "react-router-dom";
// import asyncComponent from "util/asyncComponent";
import DashboardCRM from "../../../containers/Pages/main/dashboard/CRM/DashboardCRM";

const Dashboard = ({ match }) => (
  <Switch>
    <Redirect exact from={`${match.url}/`} to={`${match.url}/crm`} />
    {/* <Route path={`${match.url}/crm`} component={asyncComponent(() => import('./CRM/Dashboard'))}/> */}
    <Route path={`${match.url}/crm`} component={DashboardCRM} />
  </Switch>
);

export default Dashboard;
